import React from "react";
import { Link } from "react-router-dom";
import { FOUNDER } from "../../utils/contactInfo";

/**
 * Named human byline for E-E-A-T — links to the author ProfilePage
 * and optionally LinkedIn (sameAs target).
 */
const JgByline = ({
  compact = false,
  showCredentials = true,
  showLinkedIn = true,
  className = "",
  style = null,
}) => (
  <div
    className={`jg-byline jg-reveal ${className}`.trim()}
    style={{
      marginTop: compact ? "1.25rem" : "2rem",
      maxWidth: "40em",
      ...style,
    }}
  >
    <p
      className="jg-label jg-label--bare"
      style={{ marginBottom: showCredentials ? "0.35rem" : 0 }}
    >
      By{" "}
      <Link to={FOUNDER.urlPath} rel="author" className="jg-link">
        {FOUNDER.name}
      </Link>
      {showLinkedIn && (
        <>
          {" · "}
          <a
            href={FOUNDER.linkedIn}
            target="_blank"
            rel="noopener noreferrer me"
            className="jg-link"
          >
            LinkedIn
          </a>
        </>
      )}
    </p>
    {showCredentials && (
      <p
        style={{
          margin: 0,
          fontSize: "0.92rem",
          lineHeight: 1.55,
          color: "var(--jg-ink-soft)",
        }}
      >
        {FOUNDER.jobTitle} at Jamil Global. {FOUNDER.credentials}.
      </p>
    )}
  </div>
);

export default JgByline;
